import React, { FC, useState } from 'react';

import { Icon } from '@iconify/react';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import BenefitItem from '~/modules/feature-access/components/Benefits/BenefitItem';
import { BenefitItemType } from '~/modules/feature-access/policy';
import projectConfig from '~/projects/config';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

const VISIBLE_BENEFITS_COUNT = 3;

type Props = {
  benefits: BenefitItemType[];
  isFullList?: boolean;
};

const Benefits: FC<Props> = ({ benefits, isFullList = false }) => {
  const { t } = useTranslation('modal');
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandButtonToggle = (): void => {
    setIsExpanded((prev) => !prev);
  };

  const visibleItems = isFullList
    ? benefits
    : isExpanded
      ? benefits
      : benefits.slice(0, VISIBLE_BENEFITS_COUNT);

  const hasHiddenItems = benefits.length > VISIBLE_BENEFITS_COUNT;

  return (
    <div className={styles.container}>
      {!isFullList && (
        <Typography
          variant={Typographies.LABEL_LARGE}
          component="div"
          className={styles.title}
        >
          {t('feature_unlock.benefits_title', {
            project: projectConfig.getProjectName(),
            defaultValue: 'More in {{project}} Unlimited',
          })}
        </Typography>
      )}

      <div className={styles.list}>
        {visibleItems.map((item, index) => (
          <BenefitItem key={index} item={item} />
        ))}
      </div>

      {!isFullList && hasHiddenItems && (
        <button
          onClick={handleExpandButtonToggle}
          className={styles.expand_button}
        >
          <Icon
            icon="material-symbols:arrow-upward-rounded"
            className={clsx(styles.expand_button__icon, {
              [styles['expand_button__icon--rotated']]: !isExpanded,
            })}
          />
          <Typography
            variant={Typographies.LABEL_LARGE}
            component="div"
            className={styles.expand_button__text}
          >
            {isExpanded
              ? t('general:show_less', 'Show Less')
              : t('general:show_all_benefits', 'Show All Benefits')}
          </Typography>
        </button>
      )}
    </div>
  );
};

export default Benefits;
